import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addSiteData, getSiteById, updateSiteData } from "../services/siteAPI";
import AppMenu from "../components/AppMenu";
import { title } from "../config";
import Select from "react-select";
import { sitePhpVersions, siteWordPressVersions, siteRunningStatus } from "../services/constant";
import { getUserDetails } from "../services/userStorage";
import { BackButton } from "../components/BackButton";
import { useToast } from "../components/ToastContext";


export default function AddSite(props) {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { recordId } = useParams();
  const [phpVersionOptions, setPhpVersionOptions] = useState([]);
  const [wordPressVersionOptions, setWordPressVersionOptions] = useState([]);
  const [runningStatusOptions, setRunningStatusOptions] = useState([]);
  const [error, setError] = useState('');
  const userDetails = getUserDetails();


  const [site, setSite] = useState({
    name: "",
    link: "",
    status: "",
    runningStatus: "",
    sslExpiry: "",
    domainExpiry: "",
    phpVersion: "",
    wordPressVersion: "",
    comment: "",
    contact: "",
  });

  const [buttonLabel, setBLabel] = useState("Add");
  const loadSite = async (id) => {
    let record = await getSiteById(id, showToast);
    setSite(record);
    setBLabel("Update");
  };
  const loadData = async () => {
    setRunningStatusOptions(siteRunningStatus);
    setPhpVersionOptions(sitePhpVersions);
    setWordPressVersionOptions(siteWordPressVersions);
  };

  useEffect(() => {
    if (recordId) {
      loadSite(recordId);
    }
    loadData();
  }, []);
  const handleChange = (e) => {
    setSite({ ...site, [e.target.name]: e.target.value });
  };
  const handlePhpVersionChange = (e) => {
    setSite({ ...site, phpVersion: e.value });
  };
  const handleWordPressVersionChange = (e) => {
    setSite({ ...site, wordPressVersion: e.value });
  };
  const handleRunningStatusChange = (e) => {
    setSite({ ...site, runningStatus: e.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!site.link || site.link.trim().length === 0) {
      setError('Link is required.');
      return;
    }

    const urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9]{2,4}(\/[^\s]*)?$/i;
    if (!urlPattern.test(site.link)) {
      setError('Please enter a valid URL.');
      return;
    }

    setError('');

    const newItem = { ...site, notetime: new Date() };
    newItem.useremail = userDetails.email;

    try {
      if (site._id !== undefined) {
        const updatedData = await updateSiteData(newItem, showToast);
        setSite(updatedData);

        showToast(
          updatedData?.msg ?? "Site updated successfully!",
          updatedData?.result === "success" ? "success" : "error"
        );

      } else {
        const addedData = await addSiteData(newItem, showToast);

        showToast(
          addedData?.msg ?? "Site added successfully!",
          addedData?.result === "success" ? "success" : "error"
        );
      }

      navigate("/site");
    } catch (error) {
      console.error(error);
      showToast("An error occurred while saving the site", "error");
    }
  };
  return (
    <div>
      <div className="px-2 sticky-header">
        <h3 className="m-0 p-2">{title} | {buttonLabel} Site</h3>
        <AppMenu />
      </div>
      <div className="p-0 m-0 px-2 pb-2">
        <BackButton text="Back" icon="←" />
        <div className="card p-5">
          <form className="container float-center needs-validation">
            <div className="row">
              <div className="col-md-4 col-sm-12 mb-3">
                <label className="form-label">Name</label>
                <input
                  placeholder="Name"
                  name="name"
                  onChange={handleChange}
                  value={site.name}
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-4 col-sm-6 mb-3">
                <label className="form-label">Link</label>
                <input
                  placeholder="Link"
                  name="link"
                  onChange={handleChange}
                  value={site.link}
                  className="form-control"
                  required
                />
                <span style={{ color: "red" }}>{error}</span>
              </div>
              <div className="col-md-2 col-sm-6 mb-3">
                <label className="form-label">PHP Version</label>
                <Select
                  name="phpVersion"
                  placeholder="PHP Version"
                  className="basic-single mb-0"
                  options={phpVersionOptions}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.name}
                  onChange={handlePhpVersionChange}
                  autoFocus={true}
                  value={phpVersionOptions.find((i) => i.value === String(site.phpVersion))}
                />
              </div>

              <div className="col-md-2 col-sm-6 mb-3">
                <label className="form-label">WordPress Version</label>
                <Select
                  name="wordPressVersion"
                  placeholder="WordPress Version"
                  className="basic-single mb-0"
                  options={wordPressVersionOptions}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.name}
                  onChange={handleWordPressVersionChange}
                  autoFocus={true}
                  value={wordPressVersionOptions.find((i) => i.value === String(site.wordPressVersion))}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-6 mb-3">
                <label className="form-label">Running Status</label>
                <Select
                  name="runningStatus"
                  className="basic-single mb-0"
                  placeholder="Select Running Status"
                  options={runningStatusOptions}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.name}
                  onChange={handleRunningStatusChange}
                  autoFocus={true}
                  value={runningStatusOptions.find((i) => i.value === site.runningStatus)}
                />
              </div>
              <div className="col-md-2 col-sm-6  mb-3">
                <label className="form-label">Cert. Exp. Date</label>
                <input
                  type="date"
                  placeholder="Date"
                  name="sslExpiry"
                  onChange={handleChange}
                  value={site.sslExpiry ? site.sslExpiry.split('T')[0] : ''}
                  className="form-control"
                />
              </div>
              <div className="col-md-2 col-sm-6  mb-3">
                <label className="form-label">Domain Exp. Date</label>
                <input
                  type="date"
                  placeholder="Date"
                  name="domainExpiry"
                  onChange={handleChange}
                  value={site.domainExpiry ? site.domainExpiry.split('T')[0] : ''}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-6 mb-3">
                <label className="form-label">Comment</label>
                <input
                  placeholder="Comment"
                  name="comment"
                  onChange={handleChange}
                  value={site.comment}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 col-sm-6 mb-3">
                <label className="form-label">Contact</label>
                <input
                  placeholder="Contact"
                  name="contact"
                  onChange={handleChange}
                  value={site.contact}
                  className="form-control"
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <input
                  type="button"
                  onClick={handleSubmit}
                  value={buttonLabel}
                  className="btn  btn-primary btn-block"
                />
              </div>
              &nbsp;&nbsp;
              <div className="col-md-2 col-sm-6">
                <input
                  type="button"
                  value="Cancel"
                  className="btn btn-block btn-secondary"
                  onClick={() => {
                    navigate("/site");
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

